// @flow

import {defineMessages} from 'react-intl';

export const messages = defineMessages({
  numberOfItems: {
    id: 'docsApp.CollapsibleJson.numberOfItems',
    description:
      'Text indicating the number of items in a collapsed collection (i.e array or object).',
    defaultMessage: `{count, plural,
        one {{count} item}
        other {{count} items}
      }`,
  },
  copyLabel: {
    id: 'docsApp.CollapsibleJson.copyLabel',
    description:
      'Label text shown when the user hovers over the copy to clipboard button.',
    defaultMessage: 'Copy',
  },
  copiedLabel: {
    id: 'docsApp.CollapsibleJson.copiedLabel',
    description:
      'Label text shown when the user clicks on the copy to clipboard button.',
    defaultMessage: 'Copied',
  },
});
